import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";
import moment from "moment";

export const createComment = async (data) => {
  const body = {
    postId: data.postId,
    studentId: _cookies.getItem("auth").user?.alunoid,
    name: _cookies.getItem("auth").user?.nome,
    comments: data.text,
    parentId: data.parentId || 0,
    commentdate: moment().format("DD/MM/YYYY H:mm"),
  };

  const res = await axios.apiCadernoVirtual.post(
    "/socialmedia-service/comments",
    body
  );

  return;
};

export const useCreateComment = ({ config } = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...config,
    mutationFn: createComment,
    onSuccess: (data, { postId }, context) => {
      queryClient.invalidateQueries({ queryKey: ["postComments", { postId }] });
    },
  });
};
